"use strict";
// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALERT_PADDING_X = exports.ALERT_PADDING = exports.CARD_SHADOW_OFFSET_Y = exports.CARD_SHADOW_BLUR_RADIUS = exports.CARD_SHADOW_ALPHA = exports.CARD_PADDING_COMPACT = exports.CARD_PADDING = exports.TABLE_COMPACT_CELL_HEIGHT = exports.TABLE_COMPACT_HEADER_HEIGHT = exports.TABLE_COMPACT_PADDING_Y = exports.TABLE_HEADER_HEIGHT = exports.TABLE_HEADER_PADDING_BOTTOM = exports.TABLE_HEADER_PADDING_TOP = exports.TABLE_HEADER_PADDING_Y = exports.TABLE_HEADER_FONT_SIZE = exports.TABLE_CELL_HEIGHT = exports.TABLE_DEFAULT_PADDING_X = exports.TABLE_DEFAULT_PADDING_Y = exports.TABLE_DEFAULT_FONT_SIZE = exports.SELECTABLE_BUTTON_SMALL_HEIGHT = exports.SELECTABLE_BUTTON_LARGE_MIN_HEIGHT = exports.SELECTABLE_BUTTON_MAX_WIDTH = exports.PAGINATION_BUTTON_LABEL_FONT_SIZE = exports.PAGINATION_BUTTON_FONT_SIZE = exports.BUTTON_RADIUS = exports.BUTTON_LG_PADDING_Y = exports.BUTTON_LG_PADDING_X = exports.BUTTON_LG_WIDTH = exports.BUTTON_SM_PADDING_Y = exports.BUTTON_SM_PADDING_X = exports.BUTTON_SM_WIDTH = exports.BUTTON_XS_PADDING_Y = exports.BUTTON_XS_PADDING_X = exports.BUTTON_XS_WIDTH = exports.BUTTON_DEFAULT_PADDING_Y = exports.BUTTON_DEFAULT_PADDING_X = exports.BUTTON_LG_FONT_SIZE = exports.BUTTON_DEFAULT_FONT_SIZE = exports.BUTTON_SM_FONT_SIZE = exports.BUTTON_XS_FONT_SIZE = exports.BUTTON_BORDER_WIDTH = exports.FORM_SET_VERTICAL_SEPARATION = exports.FORM_SET_VALIDATION_TOP_SPACING = exports.FORM_COPY_SIZE = exports.MICROCOPY_LINE_HEIGHT = exports.MICROCOPY_SIZE = exports.PAGE_TITLE_FONT_SIZE = exports.HEADING7 = exports.HEADING6 = exports.HEADING5 = exports.HEADING4 = exports.HEADING3 = exports.HEADING2 = exports.HEADING1 = exports.INLINE_ICON_SPACING_X = exports.BASE_ICON_SPACING_X = exports.BASE_SPACING_Y = exports.BASE_SPACING_X = exports.BASE_SINGLE_DIRECTION_MARGIN = exports.BASE_LINE_HEIGHT = exports.BASE_FONT_SIZE = exports.LABEL_DEFAULT_PADDING_BOTTOM = exports.LABEL_DEFAULT_PADDING_TOP = exports.SLIDER_CONTROL_SIZE = exports.INPUT_SM_HEIGHT = exports.INPUT_DEFAULT_HEIGHT = exports.INPUT_XXL_PADDING_Y = exports.INPUT_XXL_PADDING_X = exports.INPUT_XXL_LINE_HEIGHT = exports.INPUT_DEFAULT_PADDING_Y = exports.INPUT_DEFAULT_PADDING_X = exports.INPUT_BORDER_WIDTH = exports.INPUT_XXL_FONT_SIZE = exports.INPUT_SM_FONT_SIZE = exports.INPUT_FONT_SIZE = exports.DRAG_HANDLE_WIDTH = exports.DRAG_HANDLE_OFFSET_X = exports.DRAG_HANDLE_OFFSET_Y = exports.DRAG_HANDLE_HEIGHT = exports.DISTANCE_MEASUREMENT_EXTRA_LARGE = exports.DISTANCE_MEASUREMENT_LARGE = exports.DISTANCE_MEASUREMENT_MEDIUM = exports.DISTANCE_MEASUREMENT_SMALL = exports.DISTANCE_MEASUREMENT_EXTRA_SMALL = exports.EMPTY_STATE_PADDING_Y = exports.EMPTY_STATE_PADDING_X = exports.CHEVRON_PADDING_Y = exports.CHEVRON_PADDING_X = exports.CHEVRON_FONT_SIZE = exports.EXTRA_LARGE_CLOSE_BUTTON_SIZE = exports.MEDIUM_CLOSE_BUTTON_SIZE = exports.SMALL_CLOSE_BUTTON_SIZE = exports.ALERT_FONT_SIZE = exports.NAV_ITEM_PADDING_Y = exports.NAV_ITEM_PADDING_X = exports.NAV_ITEM_PADDING_RIGHT = exports.NAV_ITEM_PADDING_LEFT = exports.NAV_ITEM_INNER_SPACING_X = exports.NAV_BAR_HEIGHT = exports.ROOT_FONT_SIZE = void 0;
exports.FOCUS_RING_SHADOW_LAST_SIZES = exports.FOCUS_RING_SHADOW_SIZES = exports.FOCUS_RING_SHADOW_ALPHA = exports.FOCUS_RING_BORDER_ALPHA = exports.DEVICE_FRAME_BORDER_RADIUS = exports.DEVICE_FRAME_CAMERA_SPEAKER_SPACING = exports.DEVICE_FRAME_MOBILE_HEADER_CIRCLE = exports.DEVICE_FRAME_TABLET_HEADER_CIRCLE = exports.DEVICE_FRAME_MOBILE_FOOTER_HEIGHT = exports.DEVICE_FRAME_MOBILE_HEADER_HEIGHT = exports.DEVICE_FRAME_TABLET_HEADER_HEIGHT = exports.DEVICE_FRAME_DESKTOP_HEADER_HEIGHT = exports.DEVICE_FRAME_MOBILE_HEIGHT_RATIO = exports.DEVICE_FRAME_MOBILE_WIDTH_RATIO = exports.DEVICE_FRAME_TABLET_HEIGHT_RATIO = exports.DEVICE_FRAME_TABLET_WIDTH_RATIO = exports.DEVICE_FRAME_DESKTOP_HEIGHT_RATIO = exports.DEVICE_FRAME_DESKTOP_WIDTH_RATIO = exports.GRID_BREAKPOINT_EXTRA_LARGE = exports.GRID_BREAKPOINT_LARGE = exports.GRID_BREAKPOINT_MEDIUM = exports.GRID_BREAKPOINT_SMALL = exports.BASE_SHADOW_OFFSET_Y = exports.BASE_SHADOW_BLUR_RADIUS = exports.BASE_SHADOW_ALPHA = exports.AVATAR_SIZE_EXTRA_LARGE = exports.AVATAR_SIZE_LARGE = exports.AVATAR_SIZE_MEDIUM = exports.AVATAR_SIZE_SMALL = exports.AVATAR_SIZE_EXTRA_SMALL = exports.URANUS_LAYER = exports.SATURN_LAYER = exports.JUPITER_LAYER = exports.MARS_LAYER = exports.EARTH_LAYER = exports.VENUS_LAYER = exports.MERCURY_LAYER = exports.TAG_ICON_SPACING_X = exports.TAG_PADDING_Y = exports.TAG_PADDING_X = exports.TAG_HEIGHT = exports.TAG_FONT_SIZE_LARGE = exports.TAG_FONT_SIZE = exports.BADGE_ROUNDED_HEIGHT = exports.BADGE_ROUNDED_FONT_SIZE = exports.BADGE_FONT_SIZE = exports.BACK_BUTTON_ARROW_SIZE = exports.LAYOUT_EDITOR_PADDING = exports.LAYOUT_PADDING_X = exports.LAYOUT_NARROW_WIDTH = exports.LAYOUT_MAX_WIDTH = exports.LAYOUT_MAIN_PADDING_TOP = exports.HEADER_PADDING_BOTTOM = exports.HEADER_PADDING_TOP = exports.TOGGLE_BUTTON_SIZE_SMALL = exports.TOGGLE_BUTTON_SIZE = exports.TAB_PADDING_X = exports.TAB_PADDING_Y = exports.TAB_INDICATOR_HEIGHT = exports.TAB_FONT_SIZE = exports.DROPDOWN_CARET_OFFSET_X = exports.DROPDOWN_PADDING_X = exports.DROPDOWN_PADDING_Y = exports.DROPDOWN_FONT_SIZE = exports.DROPDOWN_ITEM_DEFAULT_HEIGHT = exports.DROPDOWN_MENU_HEIGHT = exports.SHEPHERD_PADDING_Y = exports.POPOVER_PADDING_X = exports.POPOVER_PADDING_Y = exports.TOOLTIP_PADDING_X = exports.TOOLTIP_PADDING_Y = exports.TOOLTIP_PADDING = exports.TOOLTIP_LONGFORM_PADDING = exports.TOOLTIP_LONGFORM_FONT_SIZE = exports.TOOLTIP_FONT_SIZE = exports.TOOLTIP_MAX_WIDTH = exports.TOOLBAR_HEIGHT_DARK = exports.TEXT_AREA_CODE_HEIGHT = exports.MODAL_PANEL_FOOTER_PADDING_Y = exports.MODAL_PANEL_HEADER_PADDING_Y = exports.MODAL_PANEL_PADDING_Y = exports.MODAL_PANEL_PADDING_X = exports.MODAL_OVERLAY_PADDING_Y = exports.MODAL_TALL_HEIGHT = exports.MODAL_MEDIUM_HEIGHT = exports.MODAL_SHORT_HEIGHT = exports.MODAL_CLOSE_BUTTON_OFFSET = exports.MODAL_CLOSE_BUTTON_SIZE = exports.MODAL_FOOTER_PADDING_Y = exports.MODAL_FOOTER_PADDING_X = exports.MODAL_BODY_PADDING_Y = exports.MODAL_BODY_PADDING_X = exports.MODAL_HEADER_PADDING_X = exports.MODAL_HEADER_HEIGHT = exports.INLINE_DIVIDED_LIST_SPACING_X = exports.DROP_LARGE_HEIGHT = exports.DROP_SMALL_HEIGHT = exports.ALERT_HEIGHT = exports.ALERT_PADDING_Y = void 0;
var ROOT_FONT_SIZE = '16px';
exports.ROOT_FONT_SIZE = ROOT_FONT_SIZE;
var NAV_BAR_HEIGHT = '60px';
exports.NAV_BAR_HEIGHT = NAV_BAR_HEIGHT;
var NAV_ITEM_INNER_SPACING_X = '8px';
exports.NAV_ITEM_INNER_SPACING_X = NAV_ITEM_INNER_SPACING_X;
var NAV_ITEM_PADDING_LEFT = '12px';
exports.NAV_ITEM_PADDING_LEFT = NAV_ITEM_PADDING_LEFT;
var NAV_ITEM_PADDING_RIGHT = '12px';
exports.NAV_ITEM_PADDING_RIGHT = NAV_ITEM_PADDING_RIGHT;
var NAV_ITEM_PADDING_X = '24px';
exports.NAV_ITEM_PADDING_X = NAV_ITEM_PADDING_X;
var NAV_ITEM_PADDING_Y = '12px';
exports.NAV_ITEM_PADDING_Y = NAV_ITEM_PADDING_Y;
var ALERT_FONT_SIZE = '14px';
exports.ALERT_FONT_SIZE = ALERT_FONT_SIZE;
var SMALL_CLOSE_BUTTON_SIZE = '8px';
exports.SMALL_CLOSE_BUTTON_SIZE = SMALL_CLOSE_BUTTON_SIZE;
var MEDIUM_CLOSE_BUTTON_SIZE = '12px';
exports.MEDIUM_CLOSE_BUTTON_SIZE = MEDIUM_CLOSE_BUTTON_SIZE;
var EXTRA_LARGE_CLOSE_BUTTON_SIZE = '36px';
exports.EXTRA_LARGE_CLOSE_BUTTON_SIZE = EXTRA_LARGE_CLOSE_BUTTON_SIZE;
var CHEVRON_FONT_SIZE = '12px';
exports.CHEVRON_FONT_SIZE = CHEVRON_FONT_SIZE;
var CHEVRON_PADDING_X = '12px';
exports.CHEVRON_PADDING_X = CHEVRON_PADDING_X;
var CHEVRON_PADDING_Y = '4px';
exports.CHEVRON_PADDING_Y = CHEVRON_PADDING_Y;
var EMPTY_STATE_PADDING_X = '56px';
exports.EMPTY_STATE_PADDING_X = EMPTY_STATE_PADDING_X;
var EMPTY_STATE_PADDING_Y = '20px';
exports.EMPTY_STATE_PADDING_Y = EMPTY_STATE_PADDING_Y;
var DISTANCE_MEASUREMENT_EXTRA_SMALL = '8px';
exports.DISTANCE_MEASUREMENT_EXTRA_SMALL = DISTANCE_MEASUREMENT_EXTRA_SMALL;
var DISTANCE_MEASUREMENT_SMALL = '12px';
exports.DISTANCE_MEASUREMENT_SMALL = DISTANCE_MEASUREMENT_SMALL;
var DISTANCE_MEASUREMENT_MEDIUM = '24px';
exports.DISTANCE_MEASUREMENT_MEDIUM = DISTANCE_MEASUREMENT_MEDIUM;
var DISTANCE_MEASUREMENT_LARGE = '32px';
exports.DISTANCE_MEASUREMENT_LARGE = DISTANCE_MEASUREMENT_LARGE;
var DISTANCE_MEASUREMENT_EXTRA_LARGE = '64px';
exports.DISTANCE_MEASUREMENT_EXTRA_LARGE = DISTANCE_MEASUREMENT_EXTRA_LARGE;
var DRAG_HANDLE_HEIGHT = '24px';
exports.DRAG_HANDLE_HEIGHT = DRAG_HANDLE_HEIGHT;
var DRAG_HANDLE_OFFSET_Y = '12px';
exports.DRAG_HANDLE_OFFSET_Y = DRAG_HANDLE_OFFSET_Y;
var DRAG_HANDLE_OFFSET_X = '9px';
exports.DRAG_HANDLE_OFFSET_X = DRAG_HANDLE_OFFSET_X;
var DRAG_HANDLE_WIDTH = '5px';
exports.DRAG_HANDLE_WIDTH = DRAG_HANDLE_WIDTH;
var INPUT_FONT_SIZE = '16px';
exports.INPUT_FONT_SIZE = INPUT_FONT_SIZE;
var INPUT_SM_FONT_SIZE = '14px';
exports.INPUT_SM_FONT_SIZE = INPUT_SM_FONT_SIZE;
var INPUT_XXL_FONT_SIZE = '32px';
exports.INPUT_XXL_FONT_SIZE = INPUT_XXL_FONT_SIZE;
var INPUT_BORDER_WIDTH = '1px';
exports.INPUT_BORDER_WIDTH = INPUT_BORDER_WIDTH;
var INPUT_DEFAULT_PADDING_X = '10px';
exports.INPUT_DEFAULT_PADDING_X = INPUT_DEFAULT_PADDING_X;
var INPUT_DEFAULT_PADDING_Y = '10px';
exports.INPUT_DEFAULT_PADDING_Y = INPUT_DEFAULT_PADDING_Y;
var INPUT_XXL_LINE_HEIGHT = '40px';
exports.INPUT_XXL_LINE_HEIGHT = INPUT_XXL_LINE_HEIGHT;
var INPUT_XXL_PADDING_X = '16px';
exports.INPUT_XXL_PADDING_X = INPUT_XXL_PADDING_X;
var INPUT_XXL_PADDING_Y = '16px';
exports.INPUT_XXL_PADDING_Y = INPUT_XXL_PADDING_Y;
var INPUT_DEFAULT_HEIGHT = '40px';
exports.INPUT_DEFAULT_HEIGHT = INPUT_DEFAULT_HEIGHT;
var INPUT_SM_HEIGHT = '32px';
exports.INPUT_SM_HEIGHT = INPUT_SM_HEIGHT;
var SLIDER_CONTROL_SIZE = '20px';
exports.SLIDER_CONTROL_SIZE = SLIDER_CONTROL_SIZE;
var LABEL_DEFAULT_PADDING_TOP = '8px';
exports.LABEL_DEFAULT_PADDING_TOP = LABEL_DEFAULT_PADDING_TOP;
var LABEL_DEFAULT_PADDING_BOTTOM = '4px';
exports.LABEL_DEFAULT_PADDING_BOTTOM = LABEL_DEFAULT_PADDING_BOTTOM;
var BASE_FONT_SIZE = '14px';
exports.BASE_FONT_SIZE = BASE_FONT_SIZE;
var BASE_LINE_HEIGHT = '24px';
exports.BASE_LINE_HEIGHT = BASE_LINE_HEIGHT;
var BASE_SINGLE_DIRECTION_MARGIN = '16px';
exports.BASE_SINGLE_DIRECTION_MARGIN = BASE_SINGLE_DIRECTION_MARGIN;
var BASE_SPACING_X = '12px';
exports.BASE_SPACING_X = BASE_SPACING_X;
var BASE_SPACING_Y = '6px';
exports.BASE_SPACING_Y = BASE_SPACING_Y;
var BASE_ICON_SPACING_X = '8px';
exports.BASE_ICON_SPACING_X = BASE_ICON_SPACING_X;
var INLINE_ICON_SPACING_X = '4px';
exports.INLINE_ICON_SPACING_X = INLINE_ICON_SPACING_X;
var HEADING1 = '32px';
exports.HEADING1 = HEADING1;
var HEADING2 = '24px';
exports.HEADING2 = HEADING2;
var HEADING3 = '22px';
exports.HEADING3 = HEADING3;
var HEADING4 = '20px';
exports.HEADING4 = HEADING4;
var HEADING5 = '16px';
exports.HEADING5 = HEADING5;
var HEADING6 = '14px';
exports.HEADING6 = HEADING6;
var HEADING7 = '14px';
exports.HEADING7 = HEADING7;
var PAGE_TITLE_FONT_SIZE = '28px';
exports.PAGE_TITLE_FONT_SIZE = PAGE_TITLE_FONT_SIZE;
var MICROCOPY_SIZE = '12px';
exports.MICROCOPY_SIZE = MICROCOPY_SIZE;
var MICROCOPY_LINE_HEIGHT = '18px';
exports.MICROCOPY_LINE_HEIGHT = MICROCOPY_LINE_HEIGHT;
var FORM_COPY_SIZE = '16px';
exports.FORM_COPY_SIZE = FORM_COPY_SIZE;
var FORM_SET_VALIDATION_TOP_SPACING = '9px';
exports.FORM_SET_VALIDATION_TOP_SPACING = FORM_SET_VALIDATION_TOP_SPACING;
var FORM_SET_VERTICAL_SEPARATION = '12px';
exports.FORM_SET_VERTICAL_SEPARATION = FORM_SET_VERTICAL_SEPARATION;
var BUTTON_BORDER_WIDTH = '1px';
exports.BUTTON_BORDER_WIDTH = BUTTON_BORDER_WIDTH;
var BUTTON_XS_FONT_SIZE = '12px';
exports.BUTTON_XS_FONT_SIZE = BUTTON_XS_FONT_SIZE;
var BUTTON_SM_FONT_SIZE = '12px';
exports.BUTTON_SM_FONT_SIZE = BUTTON_SM_FONT_SIZE;
var BUTTON_DEFAULT_FONT_SIZE = '14px';
exports.BUTTON_DEFAULT_FONT_SIZE = BUTTON_DEFAULT_FONT_SIZE;
var BUTTON_LG_FONT_SIZE = '44px';
exports.BUTTON_LG_FONT_SIZE = BUTTON_LG_FONT_SIZE;
var BUTTON_DEFAULT_PADDING_X = '24px';
exports.BUTTON_DEFAULT_PADDING_X = BUTTON_DEFAULT_PADDING_X;
var BUTTON_DEFAULT_PADDING_Y = '12px';
exports.BUTTON_DEFAULT_PADDING_Y = BUTTON_DEFAULT_PADDING_Y;
var BUTTON_XS_WIDTH = '26px';
exports.BUTTON_XS_WIDTH = BUTTON_XS_WIDTH;
var BUTTON_XS_PADDING_X = '12px';
exports.BUTTON_XS_PADDING_X = BUTTON_XS_PADDING_X;
var BUTTON_XS_PADDING_Y = '6px';
exports.BUTTON_XS_PADDING_Y = BUTTON_XS_PADDING_Y;
var BUTTON_SM_WIDTH = '32px';
exports.BUTTON_SM_WIDTH = BUTTON_SM_WIDTH;
var BUTTON_SM_PADDING_X = '16px';
exports.BUTTON_SM_PADDING_X = BUTTON_SM_PADDING_X;
var BUTTON_SM_PADDING_Y = '9px';
exports.BUTTON_SM_PADDING_Y = BUTTON_SM_PADDING_Y;
var BUTTON_LG_WIDTH = '40px';
exports.BUTTON_LG_WIDTH = BUTTON_LG_WIDTH;
var BUTTON_LG_PADDING_X = '18px';
exports.BUTTON_LG_PADDING_X = BUTTON_LG_PADDING_X;
var BUTTON_LG_PADDING_Y = '17px';
exports.BUTTON_LG_PADDING_Y = BUTTON_LG_PADDING_Y;
var BUTTON_RADIUS = '3px';
exports.BUTTON_RADIUS = BUTTON_RADIUS;
var PAGINATION_BUTTON_FONT_SIZE = '14px';
exports.PAGINATION_BUTTON_FONT_SIZE = PAGINATION_BUTTON_FONT_SIZE;
var PAGINATION_BUTTON_LABEL_FONT_SIZE = '14px';
exports.PAGINATION_BUTTON_LABEL_FONT_SIZE = PAGINATION_BUTTON_LABEL_FONT_SIZE;
var SELECTABLE_BUTTON_MAX_WIDTH = '200px';
exports.SELECTABLE_BUTTON_MAX_WIDTH = SELECTABLE_BUTTON_MAX_WIDTH;
var SELECTABLE_BUTTON_LARGE_MIN_HEIGHT = '180px';
exports.SELECTABLE_BUTTON_LARGE_MIN_HEIGHT = SELECTABLE_BUTTON_LARGE_MIN_HEIGHT;
var SELECTABLE_BUTTON_SMALL_HEIGHT = '56px';
exports.SELECTABLE_BUTTON_SMALL_HEIGHT = SELECTABLE_BUTTON_SMALL_HEIGHT;
var TABLE_DEFAULT_FONT_SIZE = '14px';
exports.TABLE_DEFAULT_FONT_SIZE = TABLE_DEFAULT_FONT_SIZE;
var TABLE_DEFAULT_PADDING_Y = '16px';
exports.TABLE_DEFAULT_PADDING_Y = TABLE_DEFAULT_PADDING_Y;
var TABLE_DEFAULT_PADDING_X = '24px';
exports.TABLE_DEFAULT_PADDING_X = TABLE_DEFAULT_PADDING_X;
var TABLE_CELL_HEIGHT = '72px';
exports.TABLE_CELL_HEIGHT = TABLE_CELL_HEIGHT;
var TABLE_HEADER_FONT_SIZE = '12px';
exports.TABLE_HEADER_FONT_SIZE = TABLE_HEADER_FONT_SIZE;
var TABLE_HEADER_PADDING_Y = '14px';
exports.TABLE_HEADER_PADDING_Y = TABLE_HEADER_PADDING_Y;
var TABLE_HEADER_PADDING_TOP = '8px';
exports.TABLE_HEADER_PADDING_TOP = TABLE_HEADER_PADDING_TOP;
var TABLE_HEADER_PADDING_BOTTOM = '4px';
exports.TABLE_HEADER_PADDING_BOTTOM = TABLE_HEADER_PADDING_BOTTOM;
var TABLE_HEADER_HEIGHT = '44px';
exports.TABLE_HEADER_HEIGHT = TABLE_HEADER_HEIGHT;
var TABLE_COMPACT_PADDING_Y = '8px';
exports.TABLE_COMPACT_PADDING_Y = TABLE_COMPACT_PADDING_Y;
var TABLE_COMPACT_HEADER_HEIGHT = '56px';
exports.TABLE_COMPACT_HEADER_HEIGHT = TABLE_COMPACT_HEADER_HEIGHT;
var TABLE_COMPACT_CELL_HEIGHT = '56px';
exports.TABLE_COMPACT_CELL_HEIGHT = TABLE_COMPACT_CELL_HEIGHT;
var CARD_PADDING = '40px';
exports.CARD_PADDING = CARD_PADDING;
var CARD_PADDING_COMPACT = '24px';
exports.CARD_PADDING_COMPACT = CARD_PADDING_COMPACT;
var CARD_SHADOW_ALPHA = '.12';
exports.CARD_SHADOW_ALPHA = CARD_SHADOW_ALPHA;
var CARD_SHADOW_BLUR_RADIUS = '5px';
exports.CARD_SHADOW_BLUR_RADIUS = CARD_SHADOW_BLUR_RADIUS;
var CARD_SHADOW_OFFSET_Y = '1px';
exports.CARD_SHADOW_OFFSET_Y = CARD_SHADOW_OFFSET_Y;
var ALERT_PADDING = '20px';
exports.ALERT_PADDING = ALERT_PADDING;
var ALERT_PADDING_X = '20px';
exports.ALERT_PADDING_X = ALERT_PADDING_X;
var ALERT_PADDING_Y = '8px';
exports.ALERT_PADDING_Y = ALERT_PADDING_Y;
var ALERT_HEIGHT = '60px';
exports.ALERT_HEIGHT = ALERT_HEIGHT;
var DROP_SMALL_HEIGHT = '72px';
exports.DROP_SMALL_HEIGHT = DROP_SMALL_HEIGHT;
var DROP_LARGE_HEIGHT = '198px';
exports.DROP_LARGE_HEIGHT = DROP_LARGE_HEIGHT;
var INLINE_DIVIDED_LIST_SPACING_X = '8px';
exports.INLINE_DIVIDED_LIST_SPACING_X = INLINE_DIVIDED_LIST_SPACING_X;
var MODAL_HEADER_HEIGHT = '68px';
exports.MODAL_HEADER_HEIGHT = MODAL_HEADER_HEIGHT;
var MODAL_HEADER_PADDING_X = '40px';
exports.MODAL_HEADER_PADDING_X = MODAL_HEADER_PADDING_X;
var MODAL_BODY_PADDING_X = '40px';
exports.MODAL_BODY_PADDING_X = MODAL_BODY_PADDING_X;
var MODAL_BODY_PADDING_Y = '40px';
exports.MODAL_BODY_PADDING_Y = MODAL_BODY_PADDING_Y;
var MODAL_FOOTER_PADDING_X = '40px';
exports.MODAL_FOOTER_PADDING_X = MODAL_FOOTER_PADDING_X;
var MODAL_FOOTER_PADDING_Y = '24px';
exports.MODAL_FOOTER_PADDING_Y = MODAL_FOOTER_PADDING_Y;
var MODAL_CLOSE_BUTTON_SIZE = '16px';
exports.MODAL_CLOSE_BUTTON_SIZE = MODAL_CLOSE_BUTTON_SIZE;
var MODAL_CLOSE_BUTTON_OFFSET = '24px';
exports.MODAL_CLOSE_BUTTON_OFFSET = MODAL_CLOSE_BUTTON_OFFSET;
var MODAL_SHORT_HEIGHT = '250px';
exports.MODAL_SHORT_HEIGHT = MODAL_SHORT_HEIGHT;
var MODAL_MEDIUM_HEIGHT = '408px';
exports.MODAL_MEDIUM_HEIGHT = MODAL_MEDIUM_HEIGHT;
var MODAL_TALL_HEIGHT = '700px';
exports.MODAL_TALL_HEIGHT = MODAL_TALL_HEIGHT;
var MODAL_OVERLAY_PADDING_Y = '60px';
exports.MODAL_OVERLAY_PADDING_Y = MODAL_OVERLAY_PADDING_Y;
var MODAL_PANEL_PADDING_X = '40px';
exports.MODAL_PANEL_PADDING_X = MODAL_PANEL_PADDING_X;
var MODAL_PANEL_PADDING_Y = '24px';
exports.MODAL_PANEL_PADDING_Y = MODAL_PANEL_PADDING_Y;
var MODAL_PANEL_HEADER_PADDING_Y = '26px';
exports.MODAL_PANEL_HEADER_PADDING_Y = MODAL_PANEL_HEADER_PADDING_Y;
var MODAL_PANEL_FOOTER_PADDING_Y = '20px';
exports.MODAL_PANEL_FOOTER_PADDING_Y = MODAL_PANEL_FOOTER_PADDING_Y;
var TEXT_AREA_CODE_HEIGHT = '155px';
exports.TEXT_AREA_CODE_HEIGHT = TEXT_AREA_CODE_HEIGHT;
var TOOLBAR_HEIGHT_DARK = '56px';
exports.TOOLBAR_HEIGHT_DARK = TOOLBAR_HEIGHT_DARK;
var TOOLTIP_MAX_WIDTH = '232px';
exports.TOOLTIP_MAX_WIDTH = TOOLTIP_MAX_WIDTH;
var TOOLTIP_FONT_SIZE = '13px';
exports.TOOLTIP_FONT_SIZE = TOOLTIP_FONT_SIZE;
var TOOLTIP_LONGFORM_FONT_SIZE = '12px';
exports.TOOLTIP_LONGFORM_FONT_SIZE = TOOLTIP_LONGFORM_FONT_SIZE;
var TOOLTIP_LONGFORM_PADDING = '20px';
exports.TOOLTIP_LONGFORM_PADDING = TOOLTIP_LONGFORM_PADDING;
var TOOLTIP_PADDING = '10px';
exports.TOOLTIP_PADDING = TOOLTIP_PADDING;
var TOOLTIP_PADDING_Y = '10px';
exports.TOOLTIP_PADDING_Y = TOOLTIP_PADDING_Y;
var TOOLTIP_PADDING_X = '16px';
exports.TOOLTIP_PADDING_X = TOOLTIP_PADDING_X;
var POPOVER_PADDING_Y = '20px';
exports.POPOVER_PADDING_Y = POPOVER_PADDING_Y;
var POPOVER_PADDING_X = '24px';
exports.POPOVER_PADDING_X = POPOVER_PADDING_X;
var SHEPHERD_PADDING_Y = '16px';
exports.SHEPHERD_PADDING_Y = SHEPHERD_PADDING_Y;
var DROPDOWN_MENU_HEIGHT = '220px';
exports.DROPDOWN_MENU_HEIGHT = DROPDOWN_MENU_HEIGHT;
var DROPDOWN_ITEM_DEFAULT_HEIGHT = '40px';
exports.DROPDOWN_ITEM_DEFAULT_HEIGHT = DROPDOWN_ITEM_DEFAULT_HEIGHT;
var DROPDOWN_FONT_SIZE = '14px';
exports.DROPDOWN_FONT_SIZE = DROPDOWN_FONT_SIZE;
var DROPDOWN_PADDING_Y = '8px';
exports.DROPDOWN_PADDING_Y = DROPDOWN_PADDING_Y;
var DROPDOWN_PADDING_X = '20px';
exports.DROPDOWN_PADDING_X = DROPDOWN_PADDING_X;
var DROPDOWN_CARET_OFFSET_X = '16px';
exports.DROPDOWN_CARET_OFFSET_X = DROPDOWN_CARET_OFFSET_X;
var TAB_FONT_SIZE = '14px';
exports.TAB_FONT_SIZE = TAB_FONT_SIZE;
var TAB_INDICATOR_HEIGHT = '5px';
exports.TAB_INDICATOR_HEIGHT = TAB_INDICATOR_HEIGHT;
var TAB_PADDING_Y = '12px';
exports.TAB_PADDING_Y = TAB_PADDING_Y;
var TAB_PADDING_X = '28px';
exports.TAB_PADDING_X = TAB_PADDING_X;
var TOGGLE_BUTTON_SIZE = '20px';
exports.TOGGLE_BUTTON_SIZE = TOGGLE_BUTTON_SIZE;
var TOGGLE_BUTTON_SIZE_SMALL = '16px';
exports.TOGGLE_BUTTON_SIZE_SMALL = TOGGLE_BUTTON_SIZE_SMALL;
var HEADER_PADDING_TOP = '24px';
exports.HEADER_PADDING_TOP = HEADER_PADDING_TOP;
var HEADER_PADDING_BOTTOM = '24px';
exports.HEADER_PADDING_BOTTOM = HEADER_PADDING_BOTTOM;
var LAYOUT_MAIN_PADDING_TOP = '20px';
exports.LAYOUT_MAIN_PADDING_TOP = LAYOUT_MAIN_PADDING_TOP;
var LAYOUT_MAX_WIDTH = '1280px';
exports.LAYOUT_MAX_WIDTH = LAYOUT_MAX_WIDTH;
var LAYOUT_NARROW_WIDTH = '1140px';
exports.LAYOUT_NARROW_WIDTH = LAYOUT_NARROW_WIDTH;
var LAYOUT_PADDING_X = '48px';
exports.LAYOUT_PADDING_X = LAYOUT_PADDING_X;
var LAYOUT_EDITOR_PADDING = '20px';
exports.LAYOUT_EDITOR_PADDING = LAYOUT_EDITOR_PADDING;
var BACK_BUTTON_ARROW_SIZE = '22px';
exports.BACK_BUTTON_ARROW_SIZE = BACK_BUTTON_ARROW_SIZE;
var BADGE_FONT_SIZE = '14px';
exports.BADGE_FONT_SIZE = BADGE_FONT_SIZE;
var BADGE_ROUNDED_FONT_SIZE = '10px';
exports.BADGE_ROUNDED_FONT_SIZE = BADGE_ROUNDED_FONT_SIZE;
var BADGE_ROUNDED_HEIGHT = '20px';
exports.BADGE_ROUNDED_HEIGHT = BADGE_ROUNDED_HEIGHT;
var TAG_FONT_SIZE = '12px';
exports.TAG_FONT_SIZE = TAG_FONT_SIZE;
var TAG_FONT_SIZE_LARGE = '14px';
exports.TAG_FONT_SIZE_LARGE = TAG_FONT_SIZE_LARGE;
var TAG_HEIGHT = '24px';
exports.TAG_HEIGHT = TAG_HEIGHT;
var TAG_PADDING_X = '8px';
exports.TAG_PADDING_X = TAG_PADDING_X;
var TAG_PADDING_Y = '0';
exports.TAG_PADDING_Y = TAG_PADDING_Y;
var TAG_ICON_SPACING_X = '8px';
exports.TAG_ICON_SPACING_X = TAG_ICON_SPACING_X;
var MERCURY_LAYER = '1';
exports.MERCURY_LAYER = MERCURY_LAYER;
var VENUS_LAYER = '2';
exports.VENUS_LAYER = VENUS_LAYER;
var EARTH_LAYER = '1000';
exports.EARTH_LAYER = EARTH_LAYER;
var MARS_LAYER = '1070';
exports.MARS_LAYER = MARS_LAYER;
var JUPITER_LAYER = '1111';
exports.JUPITER_LAYER = JUPITER_LAYER;
var SATURN_LAYER = '1112';
exports.SATURN_LAYER = SATURN_LAYER;
var URANUS_LAYER = '1211';
exports.URANUS_LAYER = URANUS_LAYER;
var AVATAR_SIZE_EXTRA_SMALL = '24px';
exports.AVATAR_SIZE_EXTRA_SMALL = AVATAR_SIZE_EXTRA_SMALL;
var AVATAR_SIZE_SMALL = '32px';
exports.AVATAR_SIZE_SMALL = AVATAR_SIZE_SMALL;
var AVATAR_SIZE_MEDIUM = '48px';
exports.AVATAR_SIZE_MEDIUM = AVATAR_SIZE_MEDIUM;
var AVATAR_SIZE_LARGE = '72px';
exports.AVATAR_SIZE_LARGE = AVATAR_SIZE_LARGE;
var AVATAR_SIZE_EXTRA_LARGE = '110px';
exports.AVATAR_SIZE_EXTRA_LARGE = AVATAR_SIZE_EXTRA_LARGE;
var BASE_SHADOW_ALPHA = '.08';
exports.BASE_SHADOW_ALPHA = BASE_SHADOW_ALPHA;
var BASE_SHADOW_BLUR_RADIUS = '24px';
exports.BASE_SHADOW_BLUR_RADIUS = BASE_SHADOW_BLUR_RADIUS;
var BASE_SHADOW_OFFSET_Y = '1px';
exports.BASE_SHADOW_OFFSET_Y = BASE_SHADOW_OFFSET_Y;
var GRID_BREAKPOINT_SMALL = '544px';
exports.GRID_BREAKPOINT_SMALL = GRID_BREAKPOINT_SMALL;
var GRID_BREAKPOINT_MEDIUM = '768px';
exports.GRID_BREAKPOINT_MEDIUM = GRID_BREAKPOINT_MEDIUM;
var GRID_BREAKPOINT_LARGE = '992px';
exports.GRID_BREAKPOINT_LARGE = GRID_BREAKPOINT_LARGE;
var GRID_BREAKPOINT_EXTRA_LARGE = '1200px';
exports.GRID_BREAKPOINT_EXTRA_LARGE = GRID_BREAKPOINT_EXTRA_LARGE;
var DEVICE_FRAME_DESKTOP_WIDTH_RATIO = '16';
exports.DEVICE_FRAME_DESKTOP_WIDTH_RATIO = DEVICE_FRAME_DESKTOP_WIDTH_RATIO;
var DEVICE_FRAME_DESKTOP_HEIGHT_RATIO = '10';
exports.DEVICE_FRAME_DESKTOP_HEIGHT_RATIO = DEVICE_FRAME_DESKTOP_HEIGHT_RATIO;
var DEVICE_FRAME_TABLET_WIDTH_RATIO = '3';
exports.DEVICE_FRAME_TABLET_WIDTH_RATIO = DEVICE_FRAME_TABLET_WIDTH_RATIO;
var DEVICE_FRAME_TABLET_HEIGHT_RATIO = '4';
exports.DEVICE_FRAME_TABLET_HEIGHT_RATIO = DEVICE_FRAME_TABLET_HEIGHT_RATIO;
var DEVICE_FRAME_MOBILE_WIDTH_RATIO = '9';
exports.DEVICE_FRAME_MOBILE_WIDTH_RATIO = DEVICE_FRAME_MOBILE_WIDTH_RATIO;
var DEVICE_FRAME_MOBILE_HEIGHT_RATIO = '19.5';
exports.DEVICE_FRAME_MOBILE_HEIGHT_RATIO = DEVICE_FRAME_MOBILE_HEIGHT_RATIO;
var DEVICE_FRAME_DESKTOP_HEADER_HEIGHT = '23px';
exports.DEVICE_FRAME_DESKTOP_HEADER_HEIGHT = DEVICE_FRAME_DESKTOP_HEADER_HEIGHT;
var DEVICE_FRAME_TABLET_HEADER_HEIGHT = '7%';
exports.DEVICE_FRAME_TABLET_HEADER_HEIGHT = DEVICE_FRAME_TABLET_HEADER_HEIGHT;
var DEVICE_FRAME_MOBILE_HEADER_HEIGHT = '7%';
exports.DEVICE_FRAME_MOBILE_HEADER_HEIGHT = DEVICE_FRAME_MOBILE_HEADER_HEIGHT;
var DEVICE_FRAME_MOBILE_FOOTER_HEIGHT = '7%';
exports.DEVICE_FRAME_MOBILE_FOOTER_HEIGHT = DEVICE_FRAME_MOBILE_FOOTER_HEIGHT;
var DEVICE_FRAME_TABLET_HEADER_CIRCLE = '10px';
exports.DEVICE_FRAME_TABLET_HEADER_CIRCLE = DEVICE_FRAME_TABLET_HEADER_CIRCLE;
var DEVICE_FRAME_MOBILE_HEADER_CIRCLE = '5px';
exports.DEVICE_FRAME_MOBILE_HEADER_CIRCLE = DEVICE_FRAME_MOBILE_HEADER_CIRCLE;
var DEVICE_FRAME_CAMERA_SPEAKER_SPACING = '4px';
exports.DEVICE_FRAME_CAMERA_SPEAKER_SPACING = DEVICE_FRAME_CAMERA_SPEAKER_SPACING;
var DEVICE_FRAME_BORDER_RADIUS = '6px';
exports.DEVICE_FRAME_BORDER_RADIUS = DEVICE_FRAME_BORDER_RADIUS;
var FOCUS_RING_BORDER_ALPHA = '.5';
exports.FOCUS_RING_BORDER_ALPHA = FOCUS_RING_BORDER_ALPHA;
var FOCUS_RING_SHADOW_ALPHA = '.3';
exports.FOCUS_RING_SHADOW_ALPHA = FOCUS_RING_SHADOW_ALPHA;
var FOCUS_RING_SHADOW_SIZES = '0 0 4px 1px';
exports.FOCUS_RING_SHADOW_SIZES = FOCUS_RING_SHADOW_SIZES;
var FOCUS_RING_SHADOW_LAST_SIZES = '0 0 0 1px';
exports.FOCUS_RING_SHADOW_LAST_SIZES = FOCUS_RING_SHADOW_LAST_SIZES;